import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, Confirm } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:매장공지사항
 * 세부설명:
*/

export class StoreMsg extends Component {
    static displayName = StoreMsg.name;

    constructor(props) {
        super(props);
        this.state = {
            DataList: [],
            NotiNo: null
        };
    }
    //초기화 
    componentDidMount() {
        this.CallStoreMsgData();
    }
    async CallStoreMsgData() {
        try {

            let Data = await Big3Common.Get('api/MyPage/Notice/GetWHNoticeMgtList');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ DataList: JSON.parse(Data.dataTable) });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallStoreMsgData: ", e)
        }
        return false;
    }
    async DeleteMessage() {
        try {

            let Data = await Big3Common.Post('api/MyPage/Notice/RemoveWHNoticeMgt', { notino: this.state.NotiNo });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                Big3Common.ModalAlert(bootstrap, 'AlertBox');
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("DeleteMessage: ", e)
        }
        return false;
    }
    NoticeModal() {
        let noti_title = "";
        let reg_dt = "";
        let noti_contt = "";
        if (this.state.NotiNo !== null) {
            let Data = this.state.DataList.filter(list => list.notino === this.state.NotiNo);
            if (Data.length > 0) {
                noti_title = Data[0]["noti_title"];
                reg_dt = Data[0]["reg_dt"];
                noti_contt = Data[0]["noti_contt"];
            }
        }
        return (
            <div className="modal fade" id="Notice_Modal">
                <div className="mypage_modal modal-dialog  modal-dialog-scrollable modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header s_notice_h">
                            <div className="s_notice_title_m">{noti_title}</div>
                        </div>
                        <div className="modal-body s_notice_m">
                            <div className="s_notice_date_m">{reg_dt}</div>
                            <div className="s_notice_cont_m">
                                {noti_contt}
                            </div>
                        </div>
                        <div className="modal-footer notice_modal_footer">
                            <button type="button" className="m_btn" data-bs-dismiss="modal">확인</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    render() {
        let DataList = this.state.DataList;
        let NoticeModal = this.NoticeModal();
        return (
            <div className="container_box p_margin d_padding">
                {
                    DataList.map(list =>
                        <div className="store_notice" key={list.notino}>
                            <div className="s_notice_title">{list.noti_title}</div>
                            <div className="s_notice_date">{list.reg_dt}</div>
                            <div className="s_notice_cont" onClick={() => {
                                this.setState({ NotiNo: list.notino });
                                Big3Common.ModalAlert(bootstrap, 'Notice_Modal');
                            }}>{list.noti_contt.substr(0, 200)}</div>
                            <div className="s_notice_delete" onClick={() =>
                            {
                                this.setState({NotiNo: list.notino });
                                Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
                            }}>
                            </div>
                        </div>
                    )}
                <Alert
                    id="AlertBox"
                    title="삭제되었습니다."
                    AlertClick={() => {
                        this.CallStoreMsgData();
                    }}
                />
                <Confirm
                    id="ConfirmBox"
                    title="삭제알림"
                    content="정말로 메세지를 삭제하시겠습니까?"
                    ConfirmClick={() => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);
                        this.DeleteMessage()
                    }}
                />
                {NoticeModal}
            </div>
        );
    }
}
